<template>
  <default>
    <div class="tw-w-full" id="myDiv">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <transition
          name="fade"
          mode="out-in"
          appear
          :duration="500"
      >
        <div v-if="paymentStatus"
             class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
          <p><strong>Your Payment was received successfully.</strong> <br>
            Kindly proceed to share the documents as highlighted in the sms for the processing of your policy. Thank
            you for choosing us as your preferred insurer. Pacis, For Comfort & Peace in Life.</p>
          <v-btn color="primary" :to="{name: 'Dashboard'}" class="mt-4">Dashboard</v-btn>
        </div>
        <div v-else
             class="tw-bg-red-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
          <p>Your Payment was NOT successful <br> You'll be required to retry paying</p>
          <v-btn color="primary" :to="{name: 'SavedQuotes'}" class="mt-4">Saved Quotes</v-btn>
        </div>
      </transition>

    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';

export default {
  name: 'PaymentResponse',
  components: { BreadCrumb, Default },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Payment',
          disabled: true,
          to: { name: 'PaymentResponse' },
        },
      ],
      paymentStatus: false,
    };
  },
  mounted() {
    const { status } = this.$route.query;
    if (!status) {
      this.$router.push({ name: 'Dashboard' });
    }
    this.paymentStatus = status === 'success';
  },
};
</script>
